import React from "react";
import { NextImage } from "@ecco/ui/next-image";
import { flagStyle } from "./styles";

const CountryFlagWithName = ({ icon, name }: { icon: string; name: string }) => {
    return (
        <>
            <NextImage
                blurDataURL="/assets/flags/skeleton.webp"
                sx={flagStyle}
                src={icon}
                alt=""
                unoptimized
            />
            {name}
        </>
    );
};

export default CountryFlagWithName;
